export function inAndOut (t) {
  return 3 * t * t - 2 * t * t * t;
}

export function easeOutQuad (t) {
  return t * (2 - t);
}

export function easeInQuint (t) {
  return Math.pow(t, 5);
}

export function easeOutQuint (t) {
  return 1 - Math.pow(t, 5);
}

export function inverseEaseInQuint (t) {
  return Math.pow(t, 0.2);
}
